<template>
  <div class="meter-wrapper">
    <div class="title">
      <img width="114" height="124" :src="imageSrc">
      <span class="title">
        {{ title }}
      </span>
    </div>
    <span class="result">
      {{ result }}
    </span>
  </div>
</template>

<script type="ts">
export default {
  name: "Meter",
  props: {
    imageSrc: {
      type: String
    },
    result: {
      type: String
    },
    title: {
      type: String
    }
  }
}
</script>

<style scoped lang="sass">
.result
  letter-spacing: 0
  font: normal normal 300 43px Lato
  place-self: end

  @media (min-width: 768px)
    font-size: 46px

  @media (min-width: 1264px)
    font-size: 55px
    place-self: end
    letter-spacing: 3px

  @media (min-width: 1499px)
    letter-spacing: 7px
    font-size: 70px

.meter-wrapper
  margin-bottom: 40px
  display: grid
  grid-template-columns: 1fr 1fr

  @media (min-width: 768px)
    margin-bottom: 35px

  @media (min-width: 1264px)
    grid-template-columns: 56% 44%
    margin-bottom: 67px

  @media (min-width: 1499px)
    margin-bottom: 50px

  img
    top: -48px

    @media(min-width: 1264px)
      top: -45px
</style>

<style scoped>
* {
  color: #fff;
}

img {
  position: absolute;
  left: -25px;
}

.title {
  position: relative;
  text-transform: uppercase;
  align-self: center;
  font: normal normal normal 16px/30px Lato;
  letter-spacing: 1.28px;
}

@media (max-width: 1264px) {
  .title {
    font-size: 13px !important;
  }

  img {
    width: 70px;
  }
}
</style>
